import { TranslucentOverlay } from '@colonist/clientforge';
import { createDivIn } from '../ui_utils/DomUtils.ts';
import { mountUIReactComponent } from '../ui_platform/mountUIReactComponent.tsx';
const TRANSLUCENT_OVERLAY_CONTAINER_ID = 'translucent-overlay-container';
export function showTranslucentOverlay({ title, body, confirmLabel, onConfirm }) {
    if (document.getElementById(TRANSLUCENT_OVERLAY_CONTAINER_ID) != undefined) return;
    const container = createDivIn(document.body, '', TRANSLUCENT_OVERLAY_CONTAINER_ID);
    const view = mountUIReactComponent(TRANSLUCENT_OVERLAY_CONTAINER_ID, TranslucentOverlay);
    view.render({
        title: title,
        body: body,
        ...confirmLabel != undefined ? {
            confirmLabel: confirmLabel
        } : {},
        ...onConfirm != undefined ? {
            onConfirm: ()=>{
                view.unmount();
                container.remove();
                onConfirm();
            }
        } : {}
    });
}
